import React, { useEffect, useState } from "react";
import axios from "axios";
import { BASE_URL } from "../../store/config";
import "../../assets/css/Assessment/Assessment.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faClock,
  faListCheck,
} from "@fortawesome/free-solid-svg-icons";

function AssessmentCards() {

  const [assessments, setAssessments] = useState([]);

  const [searchTerm, setSearchTerm] = useState("");
  const [sortOption, setSortOption] = useState("date-desc");


  useEffect(() => {
    fetchAssessments();
  }, []);

  const fetchAssessments = async () => {
    try {
      const token =
        localStorage.getItem("access_token") ||
        localStorage.getItem("accessToken");

      const res = await axios.get(
        `${BASE_URL}api/user-assessments`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      setAssessments(res.data);
      console.log("Fetched assessments:", res.data);
    } catch (err) {
      console.error("Error fetching assessments:", err);
    }
  };

  const filteredGuides = assessments.filter((assessment) =>
    assessment.title.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const sortedGuides = [...filteredGuides].sort((a, b) => {

    if (sortOption === "name-asc") {
      return a.title.localeCompare(b.title);
    }

    if (sortOption === "name-desc") {
      return b.title.localeCompare(a.title);
    }

    if (sortOption === "date-asc") {
      return new Date(a.created_at) - new Date(b.created_at);
    }

    if (sortOption === "date-desc") {
      return new Date(b.created_at) - new Date(a.created_at);
    }

    return 0;
  });




  return (
    <>
      <div className="assessment-section">
        {/* SEARCH + SORT */}
        {assessments.length > 0 && (
          <div className="cert-controls">

            <input
              type="text"
              placeholder="Search assessments..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="ug-search"
            />

            <select
              value={sortOption}
              onChange={(e) => setSortOption(e.target.value)}
              className="ug-sort"
            >
              <option value="date-desc">Newest First</option>
              <option value="date-asc">Oldest First</option>
              <option value="name-asc">Name (A-Z)</option>
              <option value="name-desc">Name (Z-A)</option>
            </select>

          </div>
        )}

        {/* ASSESSMENT GRID */}
        {sortedGuides.length > 0 ? (

          <div className="assessment-container">

            {sortedGuides.map((item) => (
              <div className="assessment-card" key={item.id}>
          

                {/* Image */}
                <div className="avatar">
                  <img
                    src={
                      item.image
                        ? `${BASE_URL}api${item.image}`
                        : "https://img.magnific.com/free-photo/assessment-analysics-audit-control-review-concept_53876-167136.jpg?semt=ais_hybrid&w=740&q=80"
                    }
                    alt={item.title}
                  />
                </div>

                {/* Title */}
                <h3>{item.title}</h3>

                {/* Description */}
                <p>
                  {item.description
                    ? item.description.length > 50
                      ? item.description.slice(0, 50) + "..."
                      : item.description
                    : ""}
                </p>

                {/* Meta */}
                <div className="card-meta">

                  <span>
                    <FontAwesomeIcon icon={faClock} /> {item.duration} mins
                  </span>

                  <span>
                    <FontAwesomeIcon icon={faListCheck} />{" "}
                    {item.total_question} Questions
                  </span>

                </div>

                {/* Button */}
                <button
                  className="start-btn"
                  onClick={() =>
                    window.open(
                      `/instruction/${item.id}?duration=${item.duration}`,
                      "_blank",
                      "noopener,noreferrer"
                    )
                  }
                >
                  Start Assessment
                </button>

              </div>
            ))}

          </div>

        ) : (

          <div className="empty-assessment">
            <div className="empty-assessment-card">

              <div className="empty-icon">📝</div>

              <h2>No Assessments Assigned Yet</h2>

              <p className="empty-subtitle">
                Your assessments will appear here once assigned.
              </p>

              <blockquote>
                “Every expert was once a beginner.”
              </blockquote>



              <p className="empty-hint">
                Stay prepared — assessments may unlock anytime 🚀
              </p>

            </div>
          </div>

        )}
      </div>
    </>
  );
}

export default AssessmentCards;